export declare type HTTPURL = `http:${string}` | `https:${string}`;

export const isHTTPURL = ( url: string ): url is HTTPURL => {
	return url.startsWith("http://") || url.startsWith("https://");
}

